import { ref } from 'vue';

const toasts = ref([]);

export function useZSToast() {
  const add = (toast) => {
    const id = Date.now() + Math.random();
    toasts.value.push({ ...toast, id });
  };

  const remove = (id) => {

    toasts.value = toasts.value.filter((toast) => toast.id !== id);
  };

  return { toasts, add, remove };
}
